import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { TextButton } from '@myphx-engineering/phx-design-system';

import type { DigitallyReceivedPrescriberOrderInfoFragment } from '../../../graphql/generated/graphql';
import type { DrugConfig } from '../../../types/drug-config';
import { DrugKeys } from '../../../util/config/constants';
import { getAbsoluteRoute } from '../../../util/get-absolute-route';

export type OtherOptionsLinkProps = {
    drugConfig: DrugConfig;
    order: DigitallyReceivedPrescriberOrderInfoFragment;
};

export const OtherOptionsLink: FC<OtherOptionsLinkProps> = ({
    drugConfig,
    order,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleSeeOtherOptions = useCallback(() => {
        navigate(
            getAbsoluteRoute('order.prescriberOrderId.otherOptions', {
                prescriberOrderId: order.drxId ?? '',
            })
        );
    }, [navigate, order]);

    if (
        drugConfig.drugKey !== DrugKeys.ZepboundVial &&
        drugConfig.drugKey !== DrugKeys.ZepboundKwikPen
    ) {
        return null;
    }

    return (
        <TextButton onClick={handleSeeOtherOptions}>
            {t('previewDetails.textButton.seeOptions')}
        </TextButton>
    );
};
